import ExpenseRatioHistory from './ExpenseRatioHistory'

const ExpenseRatioPanel = () => {
  return (
    <div className='h-full flex flex-col animate-in fade-in slide-in-from-bottom-2 duration-500 space-y-10 overflow-hidden'>
      <div className='flex flex-col gap-10 h-full overflow-hidden'>
        <div className='shrink-0 space-y-2'>
          <h3 className='text-xl font-semibold text-foreground'>
            Expense Ratio
          </h3>
          <p className='text-sm text-muted-foreground leading-relaxed'>
            Manage time-based overhead ratios applied on top of direct labor.
            Each period has a start date, optional end date, and a percentage —
            the active ratio is picked per time entry's start_time.
          </p>
        </div>
        <div className='flex-1 overflow-hidden md:col-span-2'>
          <ExpenseRatioHistory />
        </div>
      </div>
    </div>
  )
}

export default ExpenseRatioPanel
